import { Description } from '@/types/watchface';
import { parseVersion, uint16, uint32, uint8 } from '../utils';
import { getProtocol } from './constant';

export function genHeaderBinary(
  themeNum: number,
  basicInfo: Description,
  HEADER_LENGTH: number,
  Multilingual: boolean,
  isEditable: boolean,
  isAOD: boolean,
  isAlbum: boolean,
  colorGroupTable: string[] = [],
  powerConsumptionLevel?: string,
  support_literal?: string,
  advanced?: string,
  interactive?: string,
  isVideoAlbumWatchface?: boolean,
  protocol?: number,
  support_game?: string
): { headerBin: Buffer; headerLength: number } {
  let headerLength = HEADER_LENGTH;
  const {
    version,
    editorVersion: romVersion,
    pkgName,
    name: watchName,
    recolorTable: recolors
  } = basicInfo;
  const magicWord = uint32(0x1234a55a);
  const watchFaceVerision = version ? parseVersion(version) : 0;
  const firmWareVersion = romVersion ? parseVersion(romVersion) : 0;
  const watchface = uint32(watchFaceVerision);
  const editor = uint32(0);
  const generator = uint32(0);
  // 第二位字符表示协议版本

  const _protocol = uint32(
    protocol ?? parseInt('0x00000' + getProtocol().toString(16) + '00')
  );
  const versionFirmware = uint32(firmWareVersion);

  const colorGroupTableCount = colorGroupTable ? colorGroupTable.length : 0;

  const colorGroupCount = uint32(0);
  colorGroupCount.writeUInt8(colorGroupTableCount);
  const themeCount = uint8(themeNum);
  const recolorsArr: any[] =
    recolors && recolors != 'undefined' && recolors !== ''
      ? recolors.split(',')
      : [];

  const bgFlag = isAlbum || isVideoAlbumWatchface ? 1 : 0;
  const leftFlag = 0;
  let flags = (leftFlag << 1) + bgFlag; //设置flags的0bit 判断是否表盘背景是否可切换 1: 可切换 0: 不可切换 用于相册表盘或自定义视频表盘
  flags = isEditable || recolorsArr.length ? flags + 0x2 : flags & ~0x2; // 设置flags的1bit 是否editable
  flags = isAOD === true ? flags + 0x4 : flags & ~0x4; //设置flags的2bit 是否是AOD
  if (support_game === 'true') flags += 1 << 4;
  if (powerConsumptionLevel) flags += Number(powerConsumptionLevel) << 5;
  if (support_literal === 'true') flags += 1 << 8;
  if (interactive === 'true') flags += 1 << 9;
  if (advanced === 'true') flags += 1 << 10;

  const previewImgDataAddr = uint32(248);
  const reserved = uint32(0);
  const pkgId = Buffer.alloc(64);

  const name = Buffer.alloc(64);

  const recolorCount = uint8(recolorsArr.length);
  if (pkgName) pkgId.write(pkgName);
  else pkgId.write('1');
  if (watchName) name.write(watchName);
  let recolorOrColorGroupTable;
  if (recolorsArr.length || colorGroupTable.length) {
    const colorCount = recolorsArr.length || colorGroupTable.length;
    const firstColor = recolorsArr.length ? recolorsArr[0] : colorGroupTable[0];
    recolorOrColorGroupTable = uint32(
      parseInt(firstColor.replace(new RegExp('#', 'g'), '00'), 16)
    );
    if (colorCount > 1) {
      for (let i = 1; i < colorCount; i++) {
        const color = recolorsArr.length ? recolorsArr[i] : colorGroupTable[i];
        recolorOrColorGroupTable = Buffer.concat([
          recolorOrColorGroupTable,
          uint32(parseInt(color.replace(new RegExp('#', 'g'), '00'), 16))
        ]);
      }
    }
    headerLength +=
      (recolorsArr.length ? recolorsArr.length : colorGroupTable.length) * 4;
  }
  const nameRecord = Buffer.concat([
    uint32(0x6000000),
    uint32(0),
    uint32(0),
    uint32(0)
  ]);
  const nameBuffer = Buffer.concat([
    uint32(0xffffffff),
    nameRecord,
    Buffer.alloc(44)
  ]);
  let headerBin = Buffer.concat([
    magicWord,
    watchface,
    editor,
    generator,
    _protocol,
    versionFirmware,
    colorGroupCount, // colorgroup color_count
    themeCount,
    recolorCount, // recolor color_count
    uint16(flags),
    previewImgDataAddr,
    reserved,
    pkgId,
    Multilingual ? nameBuffer : name // name,
  ]);
  if (recolorOrColorGroupTable) {
    headerBin = Buffer.concat([headerBin, recolorOrColorGroupTable]);
  }
  return { headerBin, headerLength };
}
